import type {ReactElement} from 'react';
import {LabelledCheckbox} from '@Components/labelled-checkbox';
import {SocialPostCaptionOverwriteEvent} from '@Components/social-media/social-media.types';
import {updateCommonCaption, updateHasCommonCaption, updatePublishingParamAllCaptions} from '@Components/social-media-wizard/social-media-wizard-reducer';
import {useAppDispatch} from '@/hooks';
import type {CommonCaptionCheckboxProps} from './common-caption-checkbox.types';
import styles from './common-caption-checkbox.module.scss';

export function CommonCaptionCheckbox({accountIdsToPublishToCount, hasCommonCaption, textAreaRef}: CommonCaptionCheckboxProps): ReactElement | null {
  const dispatch = useAppDispatch();

  const overwriteAllCaptions = (): void => {
    const unifiedCaption = textAreaRef.current?.value;

    window.dispatchEvent(new CustomEvent(SocialPostCaptionOverwriteEvent));
    dispatch(updateHasCommonCaption(true));

    if (unifiedCaption) {
      dispatch(updateCommonCaption(unifiedCaption));
      dispatch(updatePublishingParamAllCaptions({caption: unifiedCaption, isMultiCharacterChange: true}));
    }
  };

  const onUseCaptionChange = (isChecked: boolean): void => {
    if (isChecked) {
      overwriteAllCaptions();
      return;
    }

    dispatch(updateHasCommonCaption(false));
  };

  if (accountIdsToPublishToCount <= 1) {
    return null;
  }

  return (
    <div className="_position-relative">
      <LabelledCheckbox
        className={styles.captionLabel}
        checkboxClassName={styles.captionCheckbox}
        onChange={onUseCaptionChange}
        isChecked={hasCommonCaption}
        label={window.i18next.t('pmwjs_use_caption_all_posts')}
      />
    </div>
  );
}
